"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAbyssProps = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useAbyssProps = function useAbyssProps(props) {
  var className = props.className,
    css = props.css,
    dataTestId = props['data-testid'];
  return (0, _react.useCallback)(function (key, additionalProps) {
    var keyArray = Array.isArray(key) ? key : [key];
    var abyssKey = keyArray.map(function (classKey) {
      return "abyss-".concat(classKey);
    });
    var cssKey = css && abyssKey.reduce(function (obj, classKey) {
      var cssClassKey = css[classKey];
      var additionalClassKey = css[additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.className];
      if (obj || cssClassKey || additionalClassKey) {
        return _objectSpread(_objectSpread(_objectSpread({}, obj && _objectSpread({}, obj)), cssClassKey && _objectSpread({}, cssClassKey)), additionalClassKey && _objectSpread({}, additionalClassKey));
      }
      return undefined;
    }, undefined);
    var additionalCss = additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.css;
    var subClassName = additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.className;
    var keyClass = subClassName ? "".concat(subClassName, " ").concat(abyssKey.join(' ')) : abyssKey.join(' ');
    return _objectSpread(_objectSpread({
      className: className ? "".concat(className, " ").concat(keyClass) : keyClass
    }, cssKey && {
      css: _objectSpread(_objectSpread({}, additionalCss), cssKey)
    }), dataTestId && {
      'data-testid': "".concat(dataTestId, "-").concat(abyssKey[0])
    });
  }, [className, css, dataTestId]);
};
exports.useAbyssProps = useAbyssProps;